<template>
    <div>
        <div class="title">{{$t('meg.Product')}}</div>
        <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">ODM Product Show</p>
        <div class="productBox">
            <li v-for="(item,index) in productData" :key="index" @click="detailsBtn(item.productId)">
                <span class="newPro1" v-if="item.isNew != 1"></span>
                <span class="newPro" v-if="item.isNew == 1">{{$t('meg.newproduct')}}</span>
                <span class="imgBox">
                    <img :src="item.productImg" alt="" style="width:4.64rem;height: 4.5rem;" >
                </span>
                <div class="productDetail">
                    <div class="leftBox">
                        <span class="productName">{{ item.productName }}</span>
                        <span class="productSM">{{ item.productExplain }}</span>
                    </div>
                    <!-- <div class="rightBox">¥ {{ item.productPrice }}</div> -->
                </div>
            </li>
        </div>
        <!-- <div class="page">{{ total }}</div> -->
        <div class="moreProduct" @click="more">{{$t('meg.viewProduct')}}</div>
    </div>
</template>

<script setup>
import { productManagement } from "@/api/home.js"
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
const router = useRouter()

onMounted(() => {
    getProduct()
})
const productData = ref([])
const total = ref("")
const getProduct = () => {
    productManagement().then(res => {
        if(res.data.code == 200) {
            productData.value = res.data.rows.slice(0, 8)
            total.value = res.data.total
        }
    })
}
const detailsBtn = (productId) => {
  router.push({ path: '/productdetails', query: { productId: productId } })
}

const more = () => {
    router.push("/product")
}
</script>

<style scoped>
.title {
    font-size: 0.3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: 0.625rem;
}

.productBox {
    margin-top: 0.9rem;
    box-sizing: border-box;
    display: flex;
    gap: 0.1rem;
    flex-wrap: wrap;
}

.productBox li {
    width: 24.5%;
    /* height: 592px; */
    background: #F6F6F6;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
}

.newPro {
    display: block;
    width: 1.25rem;
    height: 0.3rem;
    border-radius: 0.375rem 0.375rem  0.375rem  0.375rem;
    opacity: 1;
    border: 0.0125rem solid #D8D8D8;
    margin-left: .3375rem;
    margin-top: .2rem;
    line-height: .3rem;
    font-size: .2rem;
}
.newPro1 {
    display: block;
    width: 1.25rem;
    height: .3rem;
    border-radius: .375rem .375rem .375rem .375rem;
    opacity: 1;
    /* border: 1px solid #D8D8D8; */
    margin-left: .3375rem;
    margin-top: .2rem;
    line-height: .3rem;
}

.imgBox {
    margin-top: .25rem;
    display: inline-block;
}

.productDetail {
    height: 1.5rem;
    background: #e8e8e8;
    border-radius: 0rem 0rem 0rem 0rem;
    /* opacity: 0.06; */
    display: flex;
    justify-content: space-between;
    padding-bottom: .25rem;
}

.productName {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #002FA7;

}

.productSM {
    font-size: .175rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #818AA0;
    margin-top: .125rem;
    text-align: justify;
}

.leftBox {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: .25rem;
    margin-top: .1875rem;
    padding-right: 0.125rem;
}

.rightBox {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-right: .4625rem;
    margin-top: .3875rem;
}

.page {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-top: .5rem;
}

.moreProduct {
    width: 7.9rem;
    height: .825rem;
    background: #FFFFFF;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    border: .0125rem solid #000000;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    margin: .425rem auto;
    line-height: .825rem;
    cursor: pointer;
}
</style>
